export default "__VITE_ASSET__DGC3sQrm__"